import { Component, OnInit } from "@angular/core";

import { MenuItem } from "../layout/menu/menu-item";
import { LayoutCss } from "../../modules/basico/layout-css/layout-css";
import { SharedService } from "../../common/shared.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.css"],
})
export class HomeComponent implements OnInit {
  menu: MenuItem[] = [
    {
      link: [],
      icon: "fa fa-folder",
      nome: "Cadastros",
      menuItens: [
        {
          link: ["/cadastro/legislacao"],
          icon: "fa fa-address-card",
          nome: "Legislação",
        },
        {
          link: ["/cadastro/lei/create"],
          icon: "fa fa-address-card",
          nome: "Lei",
        },
        {
          link: [],
          nome: "",
          divider: true,
        },
        {
          link: ["/cadastro/banco/create"],
          icon: "fa fa-address-card",
          nome: "Banco",
        },
        {
          link: ["/cadastro/conta/create"],
          icon: "fa fa-address-card",
          nome: "Conta",
        },
        {
          link: ["/cadastro/convenio/create"],
          icon: "fa fa-address-card",
          nome: "Convênio",
        },
        {
          link: ["/cadastro/sindicato/create"],
          icon: "fa fa-address-card",
          nome: "Sindicato",
        },
        {
          link: [],
          nome: "",
          divider: true,
        },
        {
          link: ["/cadastro/cbo/create"],
          icon: "fa fa-address-card",
          nome: "CBO",
        },
        {
          link: ["/cadastro/funcao/create"],
          icon: "fa fa-address-card",
          nome: "Função",
        },
        {
          link: ["/cadastro/cargo/create"],
          icon: "fa fa-address-card",
          nome: "Cargo",
        },
        {
          link: [],
          nome: "",
          divider: true,
        },
        {
          link: ["/autonomo/autonomo/create"],
          icon: "fa fa-address-card",
          nome: "Autônomo",
        },
        {
          link: [],
          nome: "",
          divider: true,
        },
        {
          link: ["/cadastro/entidade-gestora/create"],
          icon: "fa fa-address-card",
          nome: "Entidade Gestora",
        },
        {
          link: ["/cadastro/orgao/create"],
          icon: "fa fa-address-card",
          nome: "Órgão",
        },
        {
          link: ["/cadastro/unidade-orcamentaria/create"],
          icon: "fa fa-address-card",
          nome: "Unidade Orçamentária",
        },
        {
          link: ["/cadastro/secretaria/create"],
          icon: "fa fa-address-card",
          nome: "Unidade Gestora",
        },
        {
          link: ["/cadastro/folha/create"],
          icon: "fa fa-address-card",
          nome: "Folha",
        },
        {
          link: ["/cadastro/lotacao/create"],
          icon: "fa fa-address-card",
          nome: "Lotação",
        },
        {
          link: [],
          nome: "",
          divider: true,
        },
        {
          link: ["/cadastro/jornada-trabalho/create"],
          icon: "fa fa-address-card",
          nome: "Jornada de Trabalho",
        },
        {
          link: ["/cadastro/evento/create"],
          icon: "fa fa-address-card",
          nome: "Evento",
        },
        {
          link: ["/cadastro/configuracao-gratificacao"],
          icon: "fa fa-address-card",
          nome: "Gratificação (GEAP)",
        },
        {
          link: [],
          nome: "",
          divider: true,
        },
        {
          link: [],
          icon: "fa fa-folder",
          nome: "Plano de Cargos, Carreiras e Remuneração",
          menuItens: [
            {
              link: ["/cadastro/classe/create"],
              icon: "fa fa-address-card",
              nome: "Classe",
            },
            {
              link: ["/cadastro/referencia/create"],
              icon: "fa fa-address-card",
              nome: "Referência",
            },
          ],
        },
        {
          link: [],
          nome: "",
          divider: true,
        },
        {
          link: ["/licenca/tipo-licenca/create"],
          icon: "fa fa-address-card",
          nome: "Tipo de Licença/Afastamento",
        },
        {
          link: ["/ocorrencia/tipo/create"],
          icon: "fa fa-address-card",
          nome: "Tipo de Ocorrência",
        },
        {
          link: ["/rescisao/tipo-rescisao/create"],
          icon: "fa fa-address-card",
          nome: "Tipo de Rescisão",
        },
      ],
    },
    {
      link: [],
      icon: "fas fa-table",
      nome: "Tabelas",
      menuItens: [
        {
          link: ["/cadastro/tipo-admissao/create"],
          icon: "fa fa-address-card",
          nome: "Tipo de Admissão",
        },
        {
          link: ["/cadastro/vinculo/create"],
          icon: "fa fa-address-card",
          nome: "Vínculo",
        },
        {
          link: ["/cadastro/natureza/create"],
          icon: "fa fa-address-card",
          nome: "Natureza",
        },
        {
          link: ["/cadastro/estado-civil/create"],
          icon: "fa fa-address-card",
          nome: "Estado Cívil",
        },
        {
          link: ["/cadastro/grau-instrucao/create"],
          icon: "fa fa-address-card",
          nome: "Grau de Instrução",
        },
        {
          link: ["/cadastro/situacao/create"],
          icon: "fa fa-address-card",
          nome: "Situação",
        },
        {
          link: [],
          nome: "",
          divider: true,
        },
        {
          link: ["/cadastro/situacao-tabela/create"],
          icon: "fa fa-address-card",
          nome: "Situação Tabela",
        },
        {
          link: [],
          nome: "",
          divider: true,
        },
        {
          link: [],
          icon: "fa fa-address-card",
          nome: "Previdência",
          menuItens: [
            {
              link: ["/previdencia/beneficio/create"],
              icon: "fa fa-address-card",
              nome: "Benefício",
            },
            {
              link: ["/previdencia/plano-previdenciario/create"],
              icon: "fa fa-address-card",
              nome: "Plano Previdenciário",
            },
          ],
        },
      ],
    },
    {
      link: [],
      icon: "fa fa-address-card",
      nome: "Servidor",
      menuItens: [
        {
          link: ["/servidor/servidor"],
          icon: "fa fa-address-card",
          nome: "Consulta",
        },
        {
          link: ["/servidor/sugestoes-cadastrais"],
          icon: "fa fa-edit",
          nome: "Sugestões cadastrais",
        },
        {
          link: [],
          nome: "",
          divider: true,
        },
        {
          link: ["/licenca/licenca/create"],
          icon: "fa fa-address-card",
          nome: "Licença/Afastamento",
        },
        {
          link: ["/ocorrencia/ocorrencia/create"],
          icon: "fa fa-address-card",
          nome: "Ocorrência",
        },
      ],
    },
    {
      link: [],
      icon: "fa fa-folder",
      nome: "Movimentos",
      menuItens: [
        {
          link: [],
          icon: "fa fa-folder",
          nome: "Folha",
          menuItens: [
            {
              link: ["/folha/referencia-folha/create"],
              icon: "fa fa-address-card",
              nome: "Criar",
            },
            {
              link: ["/folha/movimentacao-folha/create"],
              icon: "fa fa-address-card",
              nome: "Movimentar",
            },
            {
              link: ["/folha/calcula-folha"],
              icon: "fa fa-address-card",
              nome: "Calcular",
            },
            {
              link: ["/folha/servidor-folha"],
              icon: "fa fa-address-card",
              nome: "Manutenção",
            },
            {
              link: ["/folha/exclusao-folha-servidor"],
              icon: "fa fa-address-card",
              nome: "Excluir Servidor",
            },
            {
              link: [],
              nome: "",
              divider: true,
            },
            {
              link: [],
              icon: "fa fa-address-card",
              nome: "Folha Complementar",
              menuItens: [
                {
                  link: ["/folha/servidor-folha-complementar/create"],
                  icon: "fa fa-address-card",
                  nome: "Servidor",
                },
                {
                  link: ["/folha/servidor-folha-complementar/lote"],
                  icon: "fa fa-address-card",
                  nome: "Lote",
                },
              ],
            },
            {
              link: [],
              nome: "",
              divider: true,
            },
            {
              link: ["/folha/gerar-auxilio"],
              icon: "fa fa-address-card",
              nome: "Gerar/Excluir Auxílios",
            },
            /*            {
                          link: ['/folha/encerrar-folha'],
                          icon: 'fa fa-address-card',
                          nome: 'Encerrar/Reabrir'
                        },
            */
          ],
        },
        {
          link: [],
          icon: "fa fa-folder",
          nome: "Férias",
          menuItens: [
            {
              link: ["/ferias/programacao-ferias/create"],
              icon: "fa fa-address-card",
              nome: "Programação de Férias",
            },
            {
              link: ["/ferias/programacao-ferias/gerar"],
              icon: "fa fa-address-card",
              nome: "Programação de Férias - Geração",
            },
            {
              link: [],
              nome: "",
              divider: true,
            },
            {
              link: ["/ferias/quadro-ferias/gerar"],
              icon: "fa fa-address-card",
              nome: "Quadro de Férias",
            },
          ],
        },
        {
          link: [],
          icon: "fa fa-folder",
          nome: "Rescisão",
          menuItens: [
            {
              link: ["/rescisao/rescisao/create"],
              icon: "fa fa-address-card",
              nome: "Criar",
            },
            {
              link: [],
              nome: "",
              divider: true,
            },
            {
              link: ["/rescisao/rescisao-lote"],
              icon: "fa fa-address-card",
              nome: "Criar em Lote",
            },
            {
              link: ["/rescisao/rescisao-lote/delete"],
              icon: "fa fa-address-card",
              nome: "Excluir Lote",
            },
            {
              link: [],
              nome: "",
              divider: true,
            },
            {
              link: ["/rescisao/converter-rescisao-folha"],
              icon: "fa fa-address-card",
              nome: "Converter em Folha",
            },
            {
              link: [],
              nome: "",
              divider: true,
            },
            {
              link: ["/rescisao/enviar-esocial"],
              icon: "fa fa-address-card",
              nome: "Enviar e-Social",
            },
          ],
        },
        {
          link: [],
          icon: "fa fa-folder",
          nome: "13º Salário",
          menuItens: [
            {
              link: ["/decimo/referencia-decimo/create"],
              icon: "fa fa-address-card",
              nome: "Criar",
            },
            {
              link: ["/decimo/movimentacao-decimo/create"],
              icon: "fa fa-address-card",
              nome: "Movimentar",
            },
            {
              link: ["/decimo/calcular"],
              icon: "fa fa-address-card",
              nome: "Calcular",
            },
            {
              link: ["/decimo/consultar"],
              icon: "fa fa-address-card",
              nome: "Consultar",
            },
            {
              link: [],
              nome: "",
              divider: true,
            },
            {
              link: [],
              icon: "fa fa-address-card",
              nome: "Servidor",
              menuItens: [
                {
                  link: ["/decimo/servidor-decimo-complementar/create"],
                  icon: "fa fa-address-card",
                  nome: "Inlcuir",
                },
                {
                  link: ["/decimo/exclusao-decimo-servidor"],
                  icon: "fa fa-address-card",
                  nome: "Excluir",
                },
              ],
            },
          ],
        },
        {
          link: [],
          nome: "",
          divider: true,
        },
        {
          link: [],
          icon: "fa fa-folder",
          nome: "Autônomo",
          menuItens: [
            {
              link: ["/autonomo/autonomo-pagamento/create"],
              icon: "fa fa-address-card",
              nome: "Pagamento",
            },
          ],
        },
        {
          link: [],
          nome: "",
          divider: true,
        },
        {
          link: [],
          icon: "fa fa-folder",
          nome: "Obrigações Mensais",
          menuItens: [
            {
              link: [],
              icon: "fa fa-address-card",
              nome: "GPS",
              menuItens: [
                {
                  link: [],
                  icon: "fa fa-address-card",
                  nome: "Por Entidade Gestora",
                  menuItens: [
                    {
                      link: ["/obrigacoes/gps/create"],
                      icon: "fa fa-address-card",
                      nome: "Movimentar",
                    },
                  ],
                },
                {
                  link: [],
                  icon: "fa fa-address-card",
                  nome: "Por Folha",
                  menuItens: [
                    {
                      link: ["/obrigacoes/gps-folha/gerar"],
                      icon: "fa fa-address-card",
                      nome: "Gerar",
                    },
                    {
                      link: ["/obrigacoes/gps-folha/excluir"],
                      icon: "fa fa-address-card",
                      nome: "Excluir",
                    },
                    {
                      link: ["/obrigacoes/gps-folha/create"],
                      icon: "fa fa-address-card",
                      nome: "Movimentar",
                    },
                  ],
                },
              ],
            },
            {
              link: [],
              icon: "fa fa-address-card",
              nome: "GPM",
              menuItens: [
                {
                  link: [],
                  icon: "fa fa-address-card",
                  nome: "Por Entidade Gestora",
                  menuItens: [
                    {
                      link: ["/obrigacoes/gpm/create"],
                      icon: "fa fa-address-card",
                      nome: "Movimentar",
                    },
                  ],
                },
                {
                  link: [],
                  icon: "fa fa-address-card",
                  nome: "Por Folha",
                  menuItens: [
                    {
                      link: ["/obrigacoes/gpm-folha/gerar"],
                      icon: "fa fa-address-card",
                      nome: "Gerar",
                    },
                    {
                      link: ["/obrigacoes/gpm-folha/excluir"],
                      icon: "fa fa-address-card",
                      nome: "Excluir",
                    },
                    {
                      link: ["/obrigacoes/gpm-folha/create"],
                      icon: "fa fa-address-card",
                      nome: "Movimentar",
                    },
                  ],
                },
              ],
            },
            {
              link: [],
              icon: "fa fa-address-card",
              nome: "GFIP",
              menuItens: [
                {
                  link: ["/obrigacoes/gfip"],
                  icon: "fa fa-address-card",
                  nome: "Gerar",
                },
                {
                  link: ["/obrigacoes/gfip/list"],
                  icon: "fa fa-address-card",
                  nome: "Baixar",
                },
              ],
            },
            {
              link: [],
              nome: "",
              divider: true,
            },
            {
              link: [],
              icon: "fa fa-address-card",
              nome: "SIM",
              menuItens: [
                {
                  link: ["/obrigacoes/sim"],
                  icon: "fa fa-address-card",
                  nome: "Gerar",
                },
                {
                  link: ["/obrigacoes/sim/list"],
                  icon: "fa fa-address-card",
                  nome: "Baixar",
                },
                {
                  link: ["/obrigacoes/sim/importar"],
                  icon: "fa fa-address-card",
                  nome: "Importação",
                },
              ],
            },
            {
              link: [],
              nome: "",
              divider: true,
            },
            {
              link: ["/obrigacoes/siope"],
              icon: "fa fa-address-card",
              nome: "SIOPE",
            },
          ],
        },
        {
          link: [],
          icon: "fa fa-folder",
          nome: "Obrigações Anuais",
          menuItens: [
            {
              link: [],
              icon: "fa fa-address-card",
              nome: "DIRF",
              menuItens: [
                {
                  link: ["/obrigacoes/dirf"],
                  icon: "fa fa-address-card",
                  nome: "Criar",
                },
                {
                  link: ["/obrigacoes/dirf/list"],
                  icon: "fa fa-address-card",
                  nome: "Baixar",
                },
                {
                  link: [],
                  nome: "",
                  divider: true,
                },
                {
                  link: ["/portal-servidor/rendimentos"],
                  icon: "fa fa-folder",
                  nome: "Imprimir Rendimentos",
                },
                {
                  link: ["/obrigacoes/rendimentos-irrf"],
                  icon: "fa fa-address-card",
                  nome: "Pesquisar Rendimentos",
                },
              ],
            },
            {
              link: [],
              icon: "fa fa-address-card",
              nome: "RAIS",
              menuItens: [
                {
                  link: ["/obrigacoes/rais"],
                  icon: "fa fa-address-card",
                  nome: "Gerar",
                },
                {
                  link: ["/obrigacoes/rais/list"],
                  icon: "fa fa-address-card",
                  nome: "Baixar",
                },
              ],
            },
          ],
        },
        {
          link: [""],
          icon: "fa fa-address-card",
          nome: "eSocial",
          menuItens: [
            {
              link: [],
              icon: "fa fa-money",
              nome: "Folha de pagamento",
              menuItens: [
                {
                  link: [],
                  icon: "fa fa-search",
                  nome: "Consulta",
                  menuItens: [
                    {
                      link: ["/esocial/consulta-esocial-folha"],
                      icon: "fa fa-search",
                      nome: "Folha",
                    },
                    {
                      link: ["/esocial/consulta-esocial-decimo"],
                      icon: "fa fa-search",
                      nome: "Décimo",
                    },
                  ],
                },
                {
                  link: [],
                  icon: "fa fa-tasks",
                  nome: "Gerenciamento",
                  menuItens: [
                    {
                      link: ["/esocial/gerenciamento-esocial"],
                      icon: "fa fa-address-card",
                      nome: "Fila de ocorrências",
                    },
                    {
                      link: ["/esocial/servidor-enviar-lote-esocial"],
                      icon: "fa fa-address-card",
                      nome: "Enviar servidor em lote",
                    },
                  ],
                },
              ],
            },
            {
              link: [],
              icon: "fa fa-university",
              nome: "Receita federal",
              menuItens: [
                {
                  link: [],
                  icon: "fa fa-tasks",
                  nome: "Gerenciamento",
                  menuItens: [
                    {
                      link: ["/esocial/incluir-eventos-folha"],
                      icon: "fa fa-plus",
                      nome: "Incluir eventos Folha/Décimo",
                    },
                    {
                      link: ["/esocial/tabelas-empregador"],
                      icon: "fa fa-building",
                      nome: "Tabelas do empregador (S-1000)",
                    },
                    {
                      link: ["/esocial/excluir-eventos-folha"],
                      icon: "fa fa-eraser",
                      nome: "Excluir eventos Folha/Décimo",
                    },
                    {
                      link: ["/esocial/transmissao"],
                      icon: "fa fa-paper-plane",
                      nome: "Transmitir",
                    },
                    {
                      link: ["/esocial/importar-retorno-esocial"],
                      icon: "fa fa-upload",
                      nome: "Importar retorno (S-1207/S-1210)",
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          link: [],
          nome: "",
          divider: true,
        },
        {
          link: [],
          icon: "fa fa-folder",
          nome: "Bancos",
          menuItens: [
            {
              link: [],
              icon: "fa fa-folder",
              nome: "CEF",
              menuItens: [
                {
                  link: ["/banco/abertura-conta/104"],
                  icon: "fa fa-address-card",
                  nome: "Abertura de Conta",
                },
                {
                  link: [],
                  icon: "fa fa-folder",
                  nome: "Remessa",
                  menuItens: [
                    {
                      link: ["/banco/remessa-banco/104"],
                      icon: "fa fa-address-card",
                      nome: "Gerar",
                    },
                    {
                      link: ["/banco/remessa-banco/dowload/104"],
                      icon: "fa fa-address-card",
                      nome: "Baixar",
                    },
                  ],
                },
              ],
            },
            {
              link: [],
              icon: "fa fa-folder",
              nome: "Banco do Brasil",
              menuItens: [
                {
                  link: [],
                  icon: "fa fa-folder",
                  nome: "Remessa",
                  menuItens: [
                    {
                      link: ["/banco/remessa-banco/001"],
                      icon: "fa fa-address-card",
                      nome: "Gerar",
                    },
                    {
                      link: ["/banco/remessa-banco/dowload/001"],
                      icon: "fa fa-address-card",
                      nome: "Baixar",
                    },
                  ],
                },
              ],
            },
            {
              link: [],
              icon: "fa fa-folder",
              nome: "Bradesco",
              menuItens: [
                /*
                                {
                                  link: ['/banco/abertura-conta/todos/237'],
                                  icon: 'fa fa-address-card',
                                  nome: 'Abertura de Conta :: Carga Inicial'
                                },
                */
                {
                  link: ["/banco/abertura-conta/237"],
                  icon: "fa fa-address-card",
                  nome: "Abertura de Conta",
                },
                {
                  link: [],
                  nome: "",
                  divider: true,
                },
                {
                  link: [],
                  icon: "fa fa-folder",
                  nome: "Remessa",
                  menuItens: [
                    {
                      link: ["/banco/remessa-banco/237"],
                      icon: "fa fa-address-card",
                      nome: "Gerar",
                    },
                    {
                      link: ["/banco/remessa-banco/dowload/237"],
                      icon: "fa fa-address-card",
                      nome: "Baixar",
                    },
                  ],
                },
              ],
            },
            {
              link: [],
              icon: "fa fa-folder",
              nome: "Santander",
              menuItens: [
                {
                  link: ["/banco/abertura-conta/033"],
                  icon: "fa fa-address-card",
                  nome: "Abertura de Conta",
                },
                {
                  link: [],
                  nome: "",
                  divider: true,
                },
                {
                  link: [],
                  icon: "fa fa-folder",
                  nome: "Remessa",
                  menuItens: [
                    {
                      link: ["/banco/remessa-banco/033"],
                      icon: "fa fa-address-card",
                      nome: "Gerar",
                    },
                    {
                      link: ["/banco/remessa-banco/dowload/033"],
                      icon: "fa fa-address-card",
                      nome: "Baixar",
                    },
                    {
                      link: ["/banco/batimento-folha-remessa"],
                      icon: "fa fa-balance-scale",
                      nome: "Batimento folha × remessa",
                    },
                  ],
                },
                {
                  link: [],
                  icon: "fa fa-folder",
                  nome: "Retorno",
                  menuItens: [
                    {
                      link: ["/banco/importar-retorno-bancario/033"],
                      icon: "fa fa-upload",
                      nome: "Importar",
                    },
                    {
                      link: ["/banco/remessas-bancarias"],
                      icon: "fa fa-list",
                      nome: "Remessas",
                    },
                    {
                      link: ["/banco/status-pagamento"],
                      icon: "fa fa-users",
                      nome: "Status Pagamento",
                    },
                  ],
                },
              ],
            },
            {
              link: [],
              nome: "",
              divider: true,
            },
            {
              link: ["/banco/autorizacao-credito/report/001"],
              icon: "fa fa-address-card",
              nome: "Autorização para Crédito",
            },
          ],
        },
        {
          link: [],
          icon: "fa fa-folder",
          nome: "Consignados",
          menuItens: [
            {
              link: ["/utilitarios/importar-consignado"],
              icon: "fa fa-address-card",
              nome: "Importar",
            },
            {
              link: ["/banco/consignado-rejeitado/create"],
              icon: "fa fa-address-card",
              nome: "Rejeitados",
            },
            {
              link: [],
              nome: "",
              divider: true,
            },
            {
              link: ["/banco/gerar-margem"],
              icon: "fa fa-address-card",
              nome: "Calcular Margem",
            },
            {
              link: [],
              nome: "",
              divider: true,
            },
            {
              link: [],
              icon: "fa fa-folder",
              nome: "PASINFO",
              menuItens: [
                {
                  link: ["/banco/gerar-margem-simplificada"],
                  icon: "fa fa-address-card",
                  nome: "Gerar Margem Simplificada",
                },
                {
                  link: ["/banco/buscar-margem-simplificada"],
                  icon: "fa fa-address-card",
                  nome: "Baixar Margem Simplificada",
                },
                {
                  link: [],
                  nome: "",
                  divider: true,
                },
                {
                  link: ["/banco/psainfo/remessa/importar"],
                  icon: "fa fa-address-card",
                  nome: "Importar Arquivo de Remessa",
                },
                {
                  link: ["/banco/psainfo/remessa/exportar"],
                  icon: "fa fa-address-card",
                  nome: "Exportar Arquivo de Remessa",
                },
              ],
            },
          ],
        },
        {
          link: [],
          icon: "fa fa-folder",
          nome: "Convênios",
          menuItens: [
            {
              link: ["/utilitarios/importar-convenio"],
              icon: "fa fa-address-card",
              nome: "Importação",
            },
          ],
        },
        {
          link: [],
          icon: "fa fa-folder",
          nome: "Documentos",
          menuItens: [
            {
              link: ["/documentos/declaracao-nao-vinculo"],
              icon: "fa fa-address-card",
              nome: "Declaração Não Vínculo",
            },
          ],
        },
      ],
    },
    {
      link: [],
      icon: "fa fa-folder",
      nome: "Relatórios",
      menuItens: [
        {
          link: [],
          icon: "fa fa-folder",
          nome: "Cadastros",
          menuItens: [
            {
              link: ["/cadastro/funcao/report"],
              icon: "fa fa-address-card",
              nome: "Função",
            },
            {
              link: ["/cadastro/cargo/report"],
              icon: "fa fa-address-card",
              nome: "Cargo",
            },
            {
              link: [],
              nome: "",
              divider: true,
            },
            {
              link: ["/cadastro/orgao/report"],
              icon: "fa fa-address-card",
              nome: "Órgão",
            },
            {
              link: ["/cadastro/unidade-orcamentaria/report"],
              icon: "fa fa-address-card",
              nome: "Unidade Orçamentária",
            },
            {
              link: ["/cadastro/secretaria/report"],
              icon: "fa fa-address-card",
              nome: "Unidade Gestora",
            },
            {
              link: ["/cadastro/folha/report"],
              icon: "fa fa-address-card",
              nome: "Folha",
            },
            {
              link: ["/cadastro/lotacao/report"],
              icon: "fa fa-address-card",
              nome: "Lotação",
            },
            {
              link: [],
              nome: "",
              divider: true,
            },
            {
              link: ["/cadastro/evento/report"],
              icon: "fa fa-address-card",
              nome: "Evento",
            },
            {
              link: ["/cadastro/evento/incidencia/report"],
              icon: "fa fa-address-card",
              nome: "Evento por Incidência",
            },
            {
              link: [],
              nome: "",
              divider: true,
            },
            {
              link: [],
              icon: "fa fa-folder",
              nome: "Plano de Cargos, Carreiras e Remuneração",
              menuItens: [
                {
                  link: ["/cadastro/classe/report"],
                  icon: "fa fa-address-card",
                  nome: "Classe",
                },
                {
                  link: ["/cadastro/referencia/report"],
                  icon: "fa fa-address-card",
                  nome: "Referência",
                },
              ],
            },
            {
              link: [],
              nome: "",
              divider: true,
            },
            {
              link: [],
              icon: "fa fa-address-card",
              nome: "Previdência",
              menuItens: [
                {
                  link: ["/previdencia/beneficio/report"],
                  icon: "fa fa-address-card",
                  nome: "Benefício",
                },
              ],
            },
          ],
        },
        {
          link: [],
          nome: "",
          divider: true,
        },
        {
          link: [],
          icon: "fa fa-folder",
          nome: "Prova de vida",
          menuItens: [
            {
              link: ["/servidor/prova-vida/aniversariantes/report"],
              icon: "fa fa-address-card",
              nome: "Aniversariantes",
            },
          ],
        },
        {
          link: [],
          nome: "",
          divider: true,
        },
        {
          link: [],
          icon: "fa fa-folder",
          nome: "Servidor",
          menuItens: [
            {
              link: ["/servidor/servidor/report"],
              icon: "fa fa-address-card",
              nome: "Listagem de Servidores",
            },
            {
              link: ["/servidor/servidor/secretaria/report"],
              icon: "fa fa-address-card",
              nome: "Listagem de Servidores por  Unidade Gestora",
            },
            {
              link: ["/servidor/servidor/funcao/report"],
              icon: "fa fa-address-card",
              nome: "Listagem de Servidores por Função",
            },
            {
              link: ["/servidor/servidor/cargo/report"],
              icon: "fa fa-address-card",
              nome: "Listagem de Servidores por Cargo",
            },
            {
              link: ["/servidor/servidor/referencia/report"],
              icon: "fa fa-address-card",
              nome: "Listagem de Servidores por Referência",
            },
            {
              link: ["/servidor/servidor/situacao/report"],
              icon: "fa fa-address-card",
              nome: "Listagem de Servidores por Situação",
            },
            {
              link: ["/servidor/servidor/plano-previdenciario/report"],
              icon: "fa fa-address-card",
              nome: "Listagem de Servidores por Plano Previdenciário",
            },
            {
              link: ["/servidor/servidor/beneficio/report"],
              icon: "fa fa-address-card",
              nome: "Listagem de Servidores por Benefício",
            },
            {
              link: [],
              nome: "",
              divider: true,
            },
            {
              link: ["/servidor/servidor/contrato/inicio/secretaria/report"],
              icon: "fa fa-address-card",
              nome: "Contrato Temporário (Início) por Unidade Gestora",
            },
            {
              link: ["/servidor/servidor/contrato/termino/secretaria/report"],
              icon: "fa fa-address-card",
              nome: "Contrato Temporário (Término) por Unidade Gestora",
            },
            {
              link: [],
              nome: "",
              divider: true,
            },
            {
              link: ["/servidor/relacao-admitidos/report"],
              icon: "fa fa-address-card",
              nome: "Relação de Admitidos",
            },
            {
              link: ["/servidor/relacao-dependente/report"],
              icon: "fa fa-address-card",
              nome: "Relação de Dependentes",
            },
            {
              link: [],
              nome: "",
              divider: true,
            },
            {
              link: ["/portal-servidor/ficha-funcional"],
              icon: "fa fa-address-card",
              nome: "Ficha Funcional",
            },
            {
              link: ["/portal-servidor/ficha"],
              icon: "fa fa-address-card",
              nome: "Ficha Financeira",
            },
            {
              link: ["/portal-servidor/ficha-folha"],
              icon: "fa fa-address-card",
              nome: "Ficha Financeira por Folha",
            },
            {
              link: [],
              nome: "",
              divider: true,
            },
            {
              link: ["/servidor/pensao/recibo"],
              icon: "fa fa-address-card",
              nome: "Recibo Pensão Alimentícia",
            },
            {
              link: [],
              nome: "",
              divider: true,
            },
            {
              link: ["/servidor/servidor/bloqueado-pagamento/report"],
              icon: "fa fa-address-card",
              nome: "Listagem de Servidores Bloqueados para Pagamento",
            },
            {
              link: ["/servidor/servidor/isento-irrf/report"],
              icon: "fa fa-address-card",
              nome: "Listagem de Servidores Isentos de IRRF",
            },
          ],
        },
        {
          link: [],
          nome: "",
          divider: true,
        },
        {
          link: [],
          icon: "fa fa-folder",
          nome: "Folha",
          menuItens: [
            {
              link: [],
              icon: "fa fa-folder",
              nome: "Folha",
              menuItens: [
                /*
                        {
                          link: ['/folha/folha-pagamento-secretaria-folha/report'],
                          icon: 'fa fa-address-card',
                          nome: 'Folha por Unidade Gestora/Folha'
                        },
            */

                {
                  link: ["/folha/lista-conferencia-secretaria/report"],
                  icon: "fa fa-address-card",
                  nome: "Folha por Unidade Gestora",
                },
                {
                  link: ["/folha/lista-conferencia-folha/report"],
                  icon: "fa fa-address-card",
                  nome: "Folha por Unidade Gestora/Folha",
                },
                {
                  link: [
                    "/folha/lista-conferencia-folha-plano-previdenciario/report",
                  ],
                  icon: "fa fa-address-card",
                  nome: "Folha por Unidade Gestora/Folha/Plano Previdenciário",
                },
                {
                  link: [],
                  nome: "",
                  divider: true,
                },
                {
                  link: ["/folha/folha-evento-servidor/report"],
                  icon: "fa fa-address-card",
                  nome: "Folha por Evento/Servidor",
                },
                {
                  link: [],
                  nome: "",
                  divider: true,
                },
                {
                  link: ["/folha/comparativo"],
                  icon: "fa fa-address-card",
                  nome: "Comparativo da Folha por Evento",
                },
                /*
            {
              link: ['/folha/lista-conferencia/report'],
              icon: 'fa fa-address-card',
              nome: 'Lista de Conferência Folha'
            },
            */
              ],
            },
            {
              link: [],
              nome: "",
              divider: true,
            },
            {
              link: ["/portal-servidor/contra-cheque"],
              icon: "fa fa-address-card",
              nome: "Contracheque",
            },
            {
              link: ["/folha/lista-contra/report"],
              icon: "fa fa-address-card",
              nome: "Contracheque por Unidade Gestora/Folha",
            },
            {
              link: [],
              nome: "",
              divider: true,
            },
            {
              link: ["/folha/relacao-bancaria/report"],
              icon: "fa fa-address-card",
              nome: "Relação Bancária",
            },
            {
              link: [],
              nome: "",
              divider: true,
            },
            {
              link: [],
              icon: "fa fa-folder",
              nome: "Pensões",
              menuItens: [
                {
                  link: ["/folha/pensao-folha/report"],
                  icon: "fa fa-address-card",
                  nome: "Pensões da Folha",
                },
                {
                  link: ["/folha/pensao-folha-servidor/report"],
                  icon: "fa fa-address-card",
                  nome: "Pensões da Folha por Servidor",
                },
              ],
            },
            {
              link: [],
              icon: "fa fa-folder",
              nome: "Consignados",
              menuItens: [
                {
                  link: ["/folha/consignado-folha/report"],
                  icon: "fa fa-address-card",
                  nome: "Consignados da Folha",
                },
                {
                  link: ["/folha/consignado-folha/secretaria/report"],
                  icon: "fa fa-address-card",
                  nome: "Consignados da Folha por Unidade Gestora",
                },
                {
                  link: ["/folha/movimentacao-folha-consignado/report"],
                  icon: "fa fa-address-card",
                  nome: "Consignados da Movimentação da Folha",
                },
                {
                  link: [],
                  nome: "",
                  divider: true,
                },
                {
                  link: ["/folha/consignacao-individualizado"],
                  icon: "fa fa-address-card",
                  nome: "Carta Margem",
                },
                {
                  link: ["/folha/consignacao-secretaria"],
                  icon: "fa fa-address-card",
                  nome: "Consignação por Unidade Gestora",
                },
                {
                  link: ["/folha/consignacao-secretaria/negativo"],
                  icon: "fa fa-address-card",
                  nome: "Consignação Negativa por Unidade Gestora",
                },
              ],
            },
            {
              link: [],
              icon: "fa fa-folder",
              nome: "Convênios",
              menuItens: [
                /*
                                {
                                  link: ['/folha/consignado-folha/report'],
                                  icon: 'fa fa-address-card',
                                  nome: 'Consignados da Folha'
                                },
                */
                {
                  link: ["/folha/convenio-folha/secretaria/report"],
                  icon: "fa fa-address-card",
                  nome: "Convênios da Folha por Unidade Gestora",
                },
                /*
                                {
                                  link: ['/folha/movimentacao-folha-consignado/report'],
                                  icon: 'fa fa-address-card',
                                  nome: 'Consignados da Movimentação da Folha'
                                },
                */
              ],
            },
            {
              link: [],
              nome: "",
              divider: true,
            },
            {
              link: ["/folha/relacao-bruto-cargo/report"],
              icon: "fa fa-address-card",
              nome: "Bruto da Folha por Cargo",
            },
            {
              link: ["/folha/relacao-liquido/report"],
              icon: "fa fa-address-card",
              nome: "Líquido da Folha por Unidade Gestora",
            },
            {
              link: ["/folha/relacao-liquido-folha/report"],
              icon: "fa fa-address-card",
              nome: "Líquido da Folha por Unidade Gestora/Folha",
            },
            {
              link: ["/folha/relacao-negativo-folha-secretaria/report"],
              icon: "fa fa-address-card",
              nome: "Negativo da Folha por Unidade Gestora",
            },
            {
              link: [],
              nome: "",
              divider: true,
            },
            {
              link: [],
              icon: "fa fa-folder",
              nome: "Resumos",
              menuItens: [
                {
                  link: ["/folha/folha-evento/report"],
                  icon: "fa fa-address-card",
                  nome: "Resumo Geral",
                },
                /*
                {
                  link: ['/folha/folha-secretaria/report'],
                  icon: 'fa fa-address-card',
                  nome: 'Resumo por Unidade Gestora'
                },
                */
                {
                  link: ["/folha/folha-secretaria-evento/report"],
                  icon: "fa fa-address-card",
                  nome: "Resumo por Unidade Gestora",
                },
                /*
                {
                  link: ['/folha/folha-secretaria-folha/report'],
                  icon: 'fa fa-address-card',
                  nome: 'Resumo por Unidade Gestora/Folha'
                },
                */
                {
                  link: ["/folha/lista-conferencia-secretaria-resumo/report"],
                  icon: "fa fa-address-card",
                  nome: "Resumo por Unidade Gestora/Folha",
                },
                {
                  link: [
                    "/folha/lista-conferencia-secretaria-folha-plano-previdencario-resumo/report",
                  ],
                  icon: "fa fa-address-card",
                  nome: "Resumo por Unidade Gestora/Folha/Plano Previdenciário",
                },
                {
                  link: ["/folha/resumo-folha-funcao-beneficio/report"],
                  icon: "fa fa-address-card",
                  nome: "Resumo por Função/Benefício",
                },
              ],
            },
            {
              link: [],
              nome: "",
              divider: true,
            },
            {
              link: ["/servidor/evento/evento-fixo/report"],
              icon: "fa fa-address-card",
              nome: "Eventos Fixos da Folha por Evento/Servidor",
            },
            {
              link: ["/folha/movimentacao-folha-evento/report"],
              icon: "fa fa-address-card",
              nome: "Movimentação da Folha por Evento/Servidor",
            },
            {
              link: [],
              nome: "",
              divider: true,
            },
            {
              link: ["/folha/lista-log-calculo-folha/report"],
              icon: "fa fa-address-card",
              nome: "Log do Cáculo da Folha",
            },
          ],
        },
        {
          link: [],
          icon: "fa fa-folder",
          nome: "Férias",
          menuItens: [
            {
              link: ["/ferias/requerimento/report"],
              icon: "fa fa-address-card",
              nome: "Requerimento",
            },
            {
              link: ["/ferias/quadro-ferias/report"],
              icon: "fa fa-address-card",
              nome: "Quadro de Férias",
            },
            {
              link: [],
              nome: "",
              divider: true,
            },
            {
              link: ["/ferias/ferias/report"],
              icon: "fa fa-address-card",
              nome: "Listagem de Férias",
            },
            {
              link: ["/ferias/ferias-periodo-gozo/report"],
              icon: "fa fa-address-card",
              nome: "Listagem de Férias no Período",
            },
          ],
        },
        {
          link: [],
          icon: "fa fa-folder",
          nome: "Rescisão",
          menuItens: [
            {
              link: ["/rescisao/tipo-rescisao/report"],
              icon: "fa fa-address-card",
              nome: "Tipo de Rescisão",
            },
            {
              link: [],
              nome: "",
              divider: true,
            },
            {
              link: ["/rescisao/relacao-demitidos/report"],
              icon: "fa fa-address-card",
              nome: "Relação de Rescisões",
            },
            {
              link: [],
              nome: "",
              divider: true,
            },
            {
              link: ["/rescisao/relacao-bancaria/report"],
              icon: "fa fa-address-card",
              nome: "Relação Bancária",
            },
            {
              link: [],
              nome: "",
              divider: true,
            },
            {
              link: ["/rescisao/rescisao-secretaria/report"],
              icon: "fa fa-address-card",
              nome: "Rescisão por Unidade Gestora",
            },
            /*
            {
              link: ['/rescisao/lista-conferencia/report'],
              icon: 'fa fa-address-card',
              nome: 'Rescisão por Unidade Gestora/Folha'
            },
*/
            {
              link: ["/rescisao/rescisao-evento-servidor/report"],
              icon: "fa fa-address-card",
              nome: "Rescisão por Evento/Servidor",
            },
            {
              link: [],
              nome: "",
              divider: true,
            },
            {
              link: ["/rescisao/pensao-rescisao/report"],
              icon: "fa fa-address-card",
              nome: "Pensões da Rescisão",
            },
            {
              link: [],
              nome: "",
              divider: true,
            },
            {
              link: ["/rescisao/recibo/lote"],
              icon: "fa fa-address-card",
              nome: "Recibo Rescisão",
            },
            {
              link: [],
              nome: "",
              divider: true,
            },
            /*
                        {
                          link: ['/rescisao/resumo/evento/report'],
                          icon: 'fa fa-address-card',
                          nome: 'Resumo Geral'
                        },
            */
            {
              link: ["/rescisao/rescisao-secretaria-resumo/report"],
              icon: "fa fa-address-card",
              nome: "Resumo por Unidade Gestora/Folha",
            },
          ],
        },
        {
          link: [],
          icon: "fa fa-folder",
          nome: "13º Salário",
          menuItens: [
            {
              link: ["/decimo/lista-conferencia-secretaria/report"],
              icon: "fa fa-address-card",
              nome: "13º Salário por Unidade Gestora",
            },
            {
              link: ["/decimo/lista-conferencia/report"],
              icon: "fa fa-address-card",
              nome: "13º Salário por Unidade Gestora/Folha",
            },
            {
              link: [
                "/decimo/lista-conferencia-decimo-plano-previdenciario/report",
              ],
              icon: "fa fa-address-card",
              nome: "13º Salário por Unidade Gestora/Folha/Plano Previdencíario",
            },
            {
              link: [],
              nome: "",
              divider: true,
            },
            {
              link: ["/decimo/decimo-evento-servidor/report"],
              icon: "fa fa-address-card",
              nome: "13º Salário por Evento/Servidor",
            },
            {
              link: [],
              nome: "",
              divider: true,
            },
            {
              link: ["/decimo/relacao-bancaria/report"],
              icon: "fa fa-address-card",
              nome: "Relação Bancária",
            },
            {
              link: [],
              nome: "",
              divider: true,
            },
            {
              link: ["/decimo/pensao-decimo/report"],
              icon: "fa fa-address-card",
              nome: "Pensões do 13º Salário",
            },
            {
              link: ["/decimo/pensao-decimo-servidor/report"],
              icon: "fa fa-address-card",
              nome: "Pensões do 13º Salário por Servidor",
            },
            {
              link: [],
              nome: "",
              divider: true,
            },
            {
              link: ["/decimo/relacao-negativo-decimo-secretaria/report"],
              icon: "fa fa-address-card",
              nome: "Negativo do 13º Salário por Unidade Gestora",
            },
            {
              link: [],
              nome: "",
              divider: true,
            },
            {
              link: [],
              icon: "fa fa-folder",
              nome: "Resumos",
              menuItens: [
                {
                  link: ["/decimo/resumo-geral/report"],
                  icon: "fa fa-address-card",
                  nome: "Resumo Geral",
                },
                {
                  link: ["/decimo/resumo-secretaria/report"],
                  icon: "fa fa-address-card",
                  nome: "Resumo por Unidade Gestora",
                },
                {
                  link: ["/decimo/lista-conferencia-secretaria-resumo/report"],
                  icon: "fa fa-address-card",
                  nome: "Resumo por Unidade Gestora/Folha",
                },
                {
                  link: [
                    "/decimo/lista-conferencia-decimo-plano-previdenciario-resumo/report",
                  ],
                  icon: "fa fa-address-card",
                  nome: "Resumo por Unidade Gestora/Folha/Plano Previdencíario",
                },
              ],
            },
            {
              link: [],
              nome: "",
              divider: true,
            },
            {
              link: ["/portal-servidor/contra-cheque-decimo"],
              icon: "fa fa-address-card",
              nome: "Contracheque",
            },
            {
              link: ["/decimo/lista-contra/report"],
              icon: "fa fa-address-card",
              nome: "Contracheque por Unidade Gestora/Folha",
            },
            {
              link: [],
              nome: "",
              divider: true,
            },
            {
              link: ["/decimo/movimentacao-decimo/report"],
              icon: "fa fa-address-card",
              nome: "Movimentação do 13º Salário por Evento/Servidor",
            },
          ],
        },
        {
          link: [],
          nome: "",
          divider: true,
        },
        {
          link: [],
          icon: "fa fa-folder",
          nome: "Autônomo",
          menuItens: [
            {
              link: ["/autonomo/autonomo/report"],
              icon: "fa fa-address-card",
              nome: "Listagem de Autônomo",
            },
            {
              link: [],
              nome: "",
              divider: true,
            },
            {
              link: ["/autonomo/autonomo-pagamento/report"],
              icon: "fa fa-address-card",
              nome: "Pagamento de Autônomo",
            },
          ],
        },
        {
          link: [],
          nome: "",
          divider: true,
        },
        {
          link: [],
          icon: "fa fa-folder",
          nome: "Controle de Pagamento",
          menuItens: [
            {
              link: ["/banco/status-pagamento/report"],
              icon: "fa fa-address-card",
              nome: "Status de Pagamento",
            },
            {
              link: ["/banco/status-pagamento/secretaria/report"],
              icon: "fa fa-address-card",
              nome: "Status por Unidade Gestora",
            },
            {
              link: ["/banco/status-pagamento/por-folha/report"],
              icon: "fa fa-address-card",
              nome: "Status por Folha",
            },
          ],
        },
        {
          link: [],
          nome: "",
          divider: true,
        },
        {
          link: [],
          icon: "fa fa-folder",
          nome: "Licenças/Afastamentos",
          menuItens: [
            {
              link: ["/licenca/tipo-licenca/report"],
              icon: "fa fa-address-card",
              nome: "Tipo de Licença/Afastamento",
            },
            {
              link: [],
              nome: "",
              divider: true,
            },
            {
              link: ["/licenca/licenca-ativa/report"],
              icon: "fa fa-address-card",
              nome: "Listagem de Licenças Ativas",
            },
            {
              link: ["/licenca/licenca-data-lancamento/report"],
              icon: "fa fa-address-card",
              nome: "Listagem de Licenças por Período de Lançamento",
            },
            {
              link: ["/licenca/licenca/report"],
              icon: "fa fa-address-card",
              nome: "Listagem de Licenças por Período Inicial",
            },
          ],
        },
        {
          link: [],
          icon: "fa fa-folder",
          nome: "Ocorrências",
          menuItens: [
            {
              link: ["/ocorrencia/tipo/report"],
              icon: "fa fa-address-card",
              nome: "Tipo de Ocorrência",
            },
          ],
        },
        {
          link: [],
          nome: "",
          divider: true,
        },
        {
          link: [],
          icon: "fa fa-folder",
          nome: "Obrigações Mensais",
          menuItens: [
            {
              link: ["/servidor/frequencia/report"],
              icon: "fa fa-address-card",
              nome: "Frequência",
            },
            {
              link: [],
              nome: "",
              divider: true,
            },
            {
              link: [],
              icon: "fa fa-folder",
              nome: "GPS",
              menuItens: [
                {
                  link: ["/obrigacoes/gps/report"],
                  icon: "fa fa-address-card",
                  nome: "GUIA",
                },
                {
                  link: [],
                  nome: "",
                  divider: true,
                },
                {
                  link: ["/obrigacoes/gps-folha-listagem/report"],
                  icon: "fa fa-address-card",
                  nome: "Listagem por Folha",
                },
              ],
            },
            {
              link: [],
              icon: "fa fa-folder",
              nome: "GPM",
              menuItens: [
                {
                  link: ["/obrigacoes/gpm/report"],
                  icon: "fa fa-address-card",
                  nome: "GUIA",
                },
                {
                  link: [],
                  nome: "",
                  divider: true,
                },
                {
                  link: ["/obrigacoes/gpm-folha-listagem/report"],
                  icon: "fa fa-address-card",
                  nome: "Listagem por Folha",
                },
                {
                  link: ["/obrigacoes/gpm-folha/guia/report"],
                  icon: "fa fa-address-card",
                  nome: "GUIA por Folha",
                },
              ],
            },
            {
              link: [],
              nome: "",
              divider: true,
            },
            {
              link: [],
              icon: "fa fa-folder",
              nome: "SIM",
              menuItens: [
                {
                  link: ["/obrigacoes/sim/conferencia-folha/report"],
                  icon: "fa fa-address-card",
                  nome: "Conferência da Folha",
                },
              ],
            },
            {
              link: [],
              icon: "fa fa-folder",
              nome: "SIOPE",
              menuItens: [
                {
                  link: ["/obrigacoes/siope/divergencia-cadastral/report"],
                  icon: "fa fa-address-card",
                  nome: "Divergência Cadastral",
                },
              ],
            },
          ],
        },
      ],
    },
    {
      link: [],
      icon: "fa fa-folder",
      nome: "Utilitários",
      menuItens: [
        {
          link: [],
          icon: "fa fa-folder",
          nome: "Configuração",
          menuItens: [
            {
              link: [],
              icon: "fa fa-folder",
              nome: "Folha",
              menuItens: [
                {
                  link: ["/folha/evento-provento-folha"],
                  icon: "fa fa-address-card",
                  nome: "Provento",
                },
                {
                  link: ["/folha/evento-desconto-folha"],
                  icon: "fa fa-address-card",
                  nome: "Desconto",
                },
              ],
            },
            {
              link: ["/ferias/evento-ferias"],
              icon: "fa fa-folder",
              nome: "Férias",
            },
            {
              link: [],
              icon: "fa fa-folder",
              nome: "Rescisão",
              menuItens: [
                {
                  link: ["/rescisao/evento-provento-rescisao"],
                  icon: "fa fa-address-card",
                  nome: "Provento",
                },
                {
                  link: ["/rescisao/evento-desconto-rescisao"],
                  icon: "fa fa-address-card",
                  nome: "Desconto",
                },
              ],
            },
            {
              link: ["/decimo/evento-decimo-terceiro"],
              icon: "fa fa-folder",
              nome: "13º Salário",
            },
            {
              link: [],
              nome: "",
              divider: true,
            },
            {
              link: [],
              icon: "fa fa-folder",
              nome: "Evento",
              menuItens: [
                {
                  link: ["/cadastro/evento-composicao/create"],
                  icon: "fa fa-address-card",
                  nome: "Informação",
                },
              ],
            },
            {
              link: [],
              nome: "",
              divider: true,
            },
            {
              link: ["/cadastro/configuracao-geral"],
              icon: "fa fa-folder",
              nome: "Geral",
            },
            {
              link: ["/cadastro/configuracao-gratificacao"],
              icon: "fa fa-folder",
              nome: "Gratificação (GEAP)",
            },
            {
              link: ["/cadastro/configuracao-assinatura"],
              icon: "fa fa-folder",
              nome: "Assinaturas",
            },
            {
              link: ["/cadastro/configuracao-relatorio"],
              icon: "fa fa-folder",
              nome: "Relatórios",
            },
          ],
        },
        {
          link: [],
          nome: "",
          divider: true,
        },
        {
          link: [],
          icon: "fa fa-folder",
          nome: "Cadastro",
          menuItens: [
            {
              link: ["/utilitarios/atualizar-lotacao"],
              icon: "fa fa-folder",
              nome: "Atualizar Lotação",
            },
          ],
        },
        {
          link: [],
          nome: "",
          divider: true,
        },
        {
          link: [],
          icon: "fa fa-folder",
          nome: "Servidor",
          menuItens: [
            {
              link: ["/utilitarios/admissao-lote"],
              icon: "fa fa-folder",
              nome: "Admissão em Lote por Arquivo",
            },
            /*
                        {
                          link: ['/utilitarios/admissao-lote-sem-dados'],
                          icon: 'fa fa-folder',
                          nome: 'Admissão sem Dados Pessoais por Arquivo'
                        },
            */
            {
              link: ["/utilitarios/duplicacao-arquivo"],
              icon: "fa fa-folder",
              nome: "Admissão via Duplicação por Arquivo",
            },
            {
              link: [],
              nome: "",
              divider: true,
            },
            {
              link: ["/utilitarios/atualizar-carga-horaria"],
              icon: "fa fa-folder",
              nome: "Atualizar Carga Horária",
            },
            {
              link: ["/utilitarios/atualizar-referencia"],
              icon: "fa fa-folder",
              nome: "Atualizar Referência",
            },
            {
              link: ["/utilitarios/atualizar-pis-pasep"],
              icon: "fa fa-folder",
              nome: "Atualizar NIS (NIT/PIS/PASEP)",
            },
            {
              link: ["/utilitarios/atualizar-data-contrato"],
              icon: "fa fa-folder",
              nome: "Atualizar Data Término (Contrato Temporário)",
            },
            {
              link: ["/utilitarios/atualizar-dados-bancarios-folha"],
              icon: "fa fa-folder",
              nome: "Atualizar Dados Bancários na Folha",
            },
            {
              link: ["/utilitarios/atualizar-siope"],
              icon: "fa fa-folder",
              nome: "Atualizar SIOPE",
            },
            {
              link: ["/utilitarios/atualizar-servidor-folha"],
              icon: "fa fa-folder",
              nome: "Atualizar Folha",
            },
            {
              link: [],
              nome: "",
              divider: true,
            },
            {
              link: ["/utilitarios/excluir-servidor"],
              icon: "fa fa-folder",
              nome: "Excluir por Matrícula",
            },
            {
              link: ["/utilitarios/excluir-servidor-data-importacao"],
              icon: "fa fa-folder",
              nome: "Excluir por Data de Importação",
            },
            {
              link: [],
              nome: "",
              divider: true,
            },
            {
              link: ["/utilitarios/ativar-servidor-matricula"],
              icon: "fa fa-folder",
              nome: "Ativar via Matrícula",
            },
            {
              link: ["/utilitarios/ativar-servidor"],
              icon: "fa fa-folder",
              nome: "Ativar via Arquivo",
            },
            {
              link: ["/utilitarios/inativar-servidor-matricula"],
              icon: "fa fa-folder",
              nome: "Inativar via Matrícula",
            },
            {
              link: ["/utilitarios/inativar-servidor"],
              icon: "fa fa-folder",
              nome: "Inativar via Arquivo",
            },
            {
              link: [],
              nome: "",
              divider: true,
            },
            {
              link: ["/utilitarios/incluir-dependente"],
              icon: "fa fa-folder",
              nome: "Incluir Dependente",
            },
            {
              link: ["/utilitarios/atualizar-valor-plano-saude"],
              icon: "fa fa-folder",
              nome: "Atualizar Valor Plano de Saúde",
            },
          ],
        },
        {
          link: [],
          nome: "",
          divider: true,
        },
        {
          link: [],
          icon: "fa fa-folder",
          nome: "Evento Fixo",
          menuItens: [
            {
              link: ["/utilitarios/atualizar-evento-fixo"],
              icon: "fa fa-folder",
              nome: "Atualizar Evento Fixo",
            },
            {
              link: ["/utilitarios/atualizar-evento-fixo-arquivo"],
              icon: "fa fa-folder",
              nome: "Atualziar Evento Fixo por Arquivo",
            },
            {
              link: ["/utilitarios/importar-evento-fixo"],
              icon: "fa fa-folder",
              nome: "Importar Evento Fixo",
            },
            {
              link: [],
              nome: "",
              divider: true,
            },
            {
              link: ["/utilitarios/cessar-evento-fixo"],
              icon: "fa fa-folder",
              nome: "Cessar Evento Fixo",
            },
            {
              link: ["/utilitarios/suspender-cessacao-evento-fixo"],
              icon: "fa fa-folder",
              nome: "Suspender Cessação Evento Fixo",
            },
            {
              link: [],
              nome: "",
              divider: true,
            },
            {
              link: ["/utilitarios/excluir-evento-fixo"],
              icon: "fa fa-folder",
              nome: "Excluir Evento Fixo",
            },
            {
              link: ["/utilitarios/excluir-evento-fixo-importado"],
              icon: "fa fa-folder",
              nome: "Excluir Evento Fixo Importado",
            },
            {
              link: ["/utilitarios/excluir-evento-fixo-upload"],
              icon: "fa fa-folder",
              nome: "Excluir Evento Fixo por Arquivo",
            },
          ],
        },
        {
          link: [],
          icon: "fa fa-folder",
          nome: "Movimentação da Folha",
          menuItens: [
            {
              link: ["/utilitarios/importar-movimentacao-folha"],
              icon: "fa fa-folder",
              nome: "Importar Movimentação da Folha",
            },
            {
              link: [],
              nome: "",
              divider: true,
            },
            {
              link: ["/utilitarios/excluir-movimentacao-folha"],
              icon: "fa fa-folder",
              nome: "Excluir Movimentação da Folha",
            },
            {
              link: ["/utilitarios/excluir-movimentacao-folha-importada"],
              icon: "fa fa-folder",
              nome: "Excluir Movimentação da Folha Importada",
            },
            {
              link: [],
              nome: "",
              divider: true,
            },
            {
              link: ["/utilitarios/excluir-movimentacao-folha-consignado"],
              icon: "fa fa-folder",
              nome: "Excluir Consignados da Movimentação da Folha",
            },
            {
              link: ["/utilitarios/excluir-movimentacao-folha-convenio"],
              icon: "fa fa-folder",
              nome: "Excluir Convênios da Movimentação da Folha",
            },
          ],
        },
        {
          link: [],
          icon: "fa fa-folder",
          nome: "Atualização de Vecimento/Remuneração",
          menuItens: [
            {
              link: ["/utilitarios/atualizacao-salarial-cargo"],
              icon: "fa fa-folder",
              nome: "Cargo",
            },
            {
              link: ["/utilitarios/atualizacao-salarial-funcao"],
              icon: "fa fa-folder",
              nome: "Função",
            },
            {
              link: ["/utilitarios/atualizacao-salarial-pccr"],
              icon: "fa fa-folder",
              nome: "PCCR",
            },
          ],
        },
        {
          link: [],
          icon: "fa fa-folder",
          nome: "Movimentação do 13º Salário",
          menuItens: [
            {
              link: ["/utilitarios/importar-movimento-decimo"],
              icon: "fa fa-folder",
              nome: "Importar Movimentação do 13º Salário",
            },
            {
              link: ["/utilitarios/excluir-movimento-decimo"],
              icon: "fa fa-folder",
              nome: "Excluir Movimentação do 13º Salário",
            },
          ],
        },
        {
          link: [],
          nome: "",
          divider: true,
        },
        {
          link: ["/utilitarios/exportar-movimentacao-folha/sintetico"],
          icon: "fa fa-folder",
          nome: "Exportar Folha de Pagamento - Sintético",
        },
        {
          link: ["/utilitarios/exportar-movimentacao-folha"],
          icon: "fa fa-folder",
          nome: "Exportar Folha de Pagamento - Analítica",
        },
        {
          link: [],
          nome: "",
          divider: true,
        },
        /*
                {
                  link: ['/utilitarios/exportar-consignado-folha'],
                  icon: 'fa fa-folder',
                  nome: 'Exportar Consignados da Folha'
                },
                {
                  link: ['/utilitarios/exportar-convenio-folha'],
                  icon: 'fa fa-folder',
                  nome: 'Exportar Convênios da Folha'
                },
                {
                  link: [],
                  nome: '',
                  divider: true
                },
                {
                  link: ['/utilitarios/importar-programacao-ferias'],
                  icon: 'fa fa-folder',
                  nome: 'Importar Programação de Férias'
                },
                {
                  link: ['/utilitarios/excluir-programacao-ferias'],
                  icon: 'fa fa-folder',
                  nome: 'Excluir Programação de Férias'
                },
                {
                  link: [],
                  nome: '',
                  divider: true
                },
                        {
                          link: ['/utilitarios/importar-autonomo'],
                          icon: 'fa fa-folder',
                          nome: 'Importar Autonomo'
                        },
                */
        {
          link: [],
          icon: "fa fa-folder",
          nome: "Tabelas do Cálculo da Folha",
          menuItens: [
            {
              link: ["/utilitarios/limpar-tabela-calculo-folha-servidor"],
              icon: "fa fa-folder",
              nome: "Limpar por Servidor",
            },
            {
              link: ["/utilitarios/limpar-tabela-calculo-folha-secretaria"],
              icon: "fa fa-folder",
              nome: "Limpar por Unidade Gestora",
            },
          ],
        },
        {
          link: [],
          nome: "",
          divider: true,
        },
        {
          link: ["/utilitarios/importar-pagamento-autonomo"],
          icon: "fa fa-folder",
          nome: "Importar Pagamento de Autônomo",
        },
        {
          link: ["/utilitarios/excluir-pagamento-autonomo-importado"],
          icon: "fa fa-folder",
          nome: "Excluir Pagamento de Autônomo Importado",
        },
        {
          link: [],
          nome: "",
          divider: true,
        },
        {
          link: [],
          icon: "fa fa-folder",
          nome: "Integração",
          menuItens: [
            {
              link: [],
              icon: "fa fa-folder",
              nome: "ASSESI",
              menuItens: [
                {
                  link: ["/utilitarios/integracao/assesi/gerar-folha"],
                  icon: "fa fa-address-card",
                  nome: "Gerar Arquivo",
                },
                {
                  link: ["/utilitarios/integracao/assesi/baixar-folha"],
                  icon: "fa fa-address-card",
                  nome: "Baixar Arquivo",
                },
              ],
            },
          ],
        },
        {
          link: [],
          nome: "",
          divider: true,
        },
        {
          link: ["/utilitarios/exportar-servidores"],
          icon: "fa fa-folder",
          nome: "Exportar Servidores IPM",
        },
        {
          link: [],
          nome: "",
          divider: true,
        },
        {
          link: ["/consulta-view"],
          icon: "fa fa-search",
          nome: "Consultas Avançadas",
        },
      ],
    },
    {
      link: [],
      icon: "fa fa-folder",
      nome: "Portais",
      menuItens: [
        {
          link: [],
          icon: "fa fa-folder",
          nome: "Portal Servidor",
          menuItens: [
            {
              link: ["/portal-servidor/senha"],
              icon: "fa fa-folder",
              nome: "Gerenciar Senha",
            },
          ],
        },
        {
          link: ["/transparencia/"],
          icon: "fa fa-folder",
          nome: "Portal Transparência",
        },
      ],
    },
    {
      link: [],
      icon: "fa fa-lock",
      nome: "Segurança",
      menuItens: [
        {
          link: ["/seguranca/permissao"],
          icon: "fa fa-lock",
          nome: "Permissões",
        },
        {
          link: [],
          nome: "",
          divider: true,
        },
        {
          link: ["/servidor/log/report"],
          icon: "fa fa-lock",
          nome: "Log do Servidor",
        },
      ],
    },
    {
      link: ["/utilitarios/dashboard"],
      icon: "fa fa-chart-line",
      nome: "Dashboard",
    },
  ];

  layout: LayoutCss = new LayoutCss();

  constructor(private shared: SharedService, private router: Router) {}

  ngOnInit() {
    this.layout = this.shared.layout;

    // setTimeout(() => {
    //   this.router.navigate(["/utilitarios/dashboard"]);
    // });
  }
}
